




























import { Component, Vue } from 'vue-property-decorator';

@Component({ name: 'our-vision-page' })
export default class OurVisionComponent extends Vue {
}
